var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('bar-slider',{attrs:{"value":_vm.value,"interval":_vm.interval,"label-values":_vm.labelValues,"valid-values":_vm.validValues,"min":_vm.min,"max":_vm.max},on:{"change":_vm.onChangeSlider}})}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-711f2f14","hasScoped":false,"optionsId":"11","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug&optionsId=11!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/n-slider-vrnet.vue
// module id = r1HL
// module chunks = 0